<template>
   <div class="asset-wrapper active no-edit">
      <div id="color_asset" :style="noEditStyle">
         <div class="color-bg" :style="zone.style"></div>
      </div>
   </div>
</template>

<script>
import Zone from './Zone'

export default {
   extends: Zone,

}
</script>

<style lang="scss">

#color_asset {
   position: absolute;

   .color-bg {
      width: 100%;
      height: 100%;
   }
}
</style>